import React from 'react';

import { Chip } from '@mui/material';
import { convertAccBadgeInfo } from '../../utils/useAccessLevel';


export const AccBadge = ({ acc, typeAcc }) => {

  const {label, color, laColor} = convertAccBadgeInfo(acc, typeAcc);
  
  return (
    <Chip 
      sx={{
        backgroundColor: color, 
        color: laColor, 
        borderRadius: 0, 
        fontWeight: 700
      }} 
      label={label}
    />
  );
}; 